:host {
  display: block;
}

.mo-checkout {
  max-width: 747px;
  background: #F4F4F4;
  padding: 32px 25px;
  display: grid;
  grid-template-columns: 1fr 220px;
  gap: 20px;
  align-items: flex-end;
}
.mo-checkout__info > h4 {
  font-family: 'Benton-Bold';
  color: #073382;
  margin: 0;
  margin-bottom: 10px;
}

.mo-checkout__info .mo-checkout__items {
  display: grid;
  grid-template-columns: 150px 150px 150px;
  min-height: 50px;
  align-items: center;
}

.mo-checkout__info > div div{
  font-family: 'Benton-Regular';
  text-align: left;
  font-size: 14px;
  min-height: 50px;
  display: flex;
  width: 150px;
  align-items: flex-start;
}
.mo-checkout__item img{
  margin-right: 7px;
  width: 16px;
}
.mo-checkout__item b{
  font-family: 'Benton-Medium'
}

.mo-checkout__info > div div:nth-child(3){
  padding: 0 20px;
}

.mo-checkout__info > div div span.green{
  color: #318252;
}

.mo-checkout__info > div div span.purple{
  color: #9930E2;
}
.mo-checkout__info > div div b.purple{
  color: #9930E2;
}
.mo-checkout__info .info-text {
  display: flex;
  align-items: flex-start;
}

.mo-checkout__info .info-text p{
  color: #666666;
  font-family: 'Benton-Regular';
  text-align: left;
  font-size: 12px;
  margin: 0;
  margin-left: 5px;

  
}

.mo-checkout__info .regular {
  font-family: 'Benton-Regular';
  text-align: left;
  font-size: 12px;
}

.mo-checkout__info .bold {
  font-family: 'Benton-Bold';
  text-align: left;
  font-size: 14px;
}

.mo-checkout__button button {
  all: unset;
  font-family: 'Benton-Bold';
  background: #9930E2;
  border-radius: 25px;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #FFFFFF;
  width: 100%;
  padding: 10px 0;
  text-align: center;
  cursor: pointer;
}

.mo-checkout.mo-mobile {
  display: block;
}

.mo-mobile .mo-checkout__info > .mo-checkout__items {
  display: block;
}

.mo-mobile .mo-checkout__info > .mo-checkout__items .mo-checkout__item span{
  white-space: nowrap;
}

.mo-mobile .mo-checkout__info > .mo-checkout__items .mo-checkout__item br{
  display: none;
}

.mo-mobile .mo-checkout__button button {
  display: none;
}
.mo-mobile .mo-checkout__info .info-text {
  margin-bottom: 12px;
}
.mo-mobile .mo-checkout__info .info-text br {
  display: none;
}

.mo-mobile .mo-checkout__info > div div:nth-child(2){
  padding: 0;
  border: none;
}

.mo-mobile .mo-checkout__info > div div:nth-child(3){
  padding: 0;
}

.mo-mobile .mo-checkout__info > div div{
  min-height: 32px;
}